import React from 'react';
import clsx from 'clsx';

import { ReactComponent as InfoIcon } from 'assets/info.svg';

import { TooltipAnchor, TooltipFloat } from '../Tooltip';
import { useTooltipState } from '../Tooltip.hooks';
import { INFOTIP_ANCHOR_TEST_ID, INFOTIP_FLOAT_TEST_ID } from '../Tooltip.test-ids';

import styles from './infotip.module.scss';

type InfotipProps = {
  anchorClassName?: string;
  floatClassName?: string;
} & React.HTMLAttributes<HTMLDivElement>;

const Infotip: React.FC<InfotipProps> = ({ children, anchorClassName, floatClassName }) => {
  const state = useTooltipState({ placement: 'top-end' });
  const infotipFloatClassnames = clsx(styles.infotipContent, floatClassName);
  return (
    <>
      <TooltipAnchor state={state} aria-label='Opens tooltip' className={anchorClassName}>
        <InfoIcon data-testid={INFOTIP_ANCHOR_TEST_ID} className={styles.infotipAnchorIcon} />
      </TooltipAnchor>
      <TooltipFloat state={state} overlay={true} data-testid={INFOTIP_FLOAT_TEST_ID}>
        <div className={infotipFloatClassnames}>{children}</div>
      </TooltipFloat>
    </>
  );
};

export default Infotip;
